import { createSlice } from '@reduxjs/toolkit'
import { generateUUID } from 'utils/helpers'
const initialState = {
  arn: [],
  arnFileLoader: false,
  arnFileLoaderId: ''
}
export const arnFilesSlice = createSlice({
  name: 'arn_files',
  initialState,
  reducers: {
    initializeArnFiles: () => {
      return { ...initialState }
    },
    setArnFile: (state, action) => {
      const { arn } = action.payload
      state.arn.push({ ...arn })
    },
    setArnFiles: (state, action) => {
      const { arns } = action.payload
      state.arn = arns
      return state
    },
    updateArnFile: (state, action) => {
      const { arns } = action.payload
      state.arn = arns
      return state
    },
   
    setArnImage: (state, action) => {
      const { id } = action.payload

      const itemIndex = state.arn.findIndex((_, idx) => idx === id?.idx)

      if (itemIndex !== -1 && id) {
        if (!state.arn[itemIndex].files) {
          state.arn[itemIndex].files = []
        }
        if (id?.file?.file_obj) {
          const fileObj = id.file.file_obj
          const structuredFile = {
            id: fileObj.id || generateUUID(),
            file_obj: {
              id: fileObj.id,
              document_revision_id: fileObj.document_revision_id,
              name: fileObj.name || fileObj.fileName
            },
            name: fileObj.name || fileObj.fileName
          }
          state.arn[itemIndex].files.push(structuredFile)
        }
      }
    },
   
    setArnDocumentsFromAPI: (state, action) => {
      state.arn = action.payload
      return state
    },
    setArnDocFileWithData: (state, action) => {
      const { no, file } = action.payload

      // Ensure the misc document exists
      if (!state.arn[no]) {
        state.arn[no] = { files: [] }
      }

      // Ensure the files array exists
      if (!state.arn[no].files) {
        state.arn[no].files = []
      }

      state.arn[no].files.push(file)
      return state
    },
    removeArnDocFile: (state, action) => {
      var no = action.payload.no
      var file_no = action.payload.file_no
      state.arn[no].files.splice(file_no, 1)
      return state
    },
    deleteArnFile: (state, action) => {
      const { id = '' } = action.payload
      const updatedFiles = state.arn.filter(file => file.id !== id)
      return {
        ...state,
        arn: updatedFiles
      }
    },
    deleteArnImage: (state, action) => {
      const { id } = action.payload

      // If the payload id matches an ARN node id, remove the whole node
      const nodeIndexById = state.arn.findIndex(node => node.id === id)
      if (nodeIndexById !== -1) {
        state.arn.splice(nodeIndexById, 1)
        return
      }
    },
    deleteArnByIndex: (state, action) => {
      const { index } = action.payload
      if (index >= 0 && index < state.arn.length) {
        state.arn.splice(index, 1)
      }
    },
    addArnDocData: (state, action) => {
      return {
        ...state,
        arn: [...(Array.isArray(state.arn) ? state.arn : []), action.payload]
      }
    },
  }
})
export const {
  setArnFile,
  setArnFiles,
  updateArnFile,
  deleteArnFile,
  setArnImage,
  initializeArnFiles,
  setArnDocumentsFromAPI,
  setArnDocFileWithData,
  removeArnDocFile,
  deleteArnImage,
  deleteArnByIndex,
  addArnDocData
} = arnFilesSlice.actions
export default arnFilesSlice.reducer
